import Vue from "vue";
import FormBuilder from "@/components/common/forms/FormBuilder";
import ITable from "@/components/common/table/ITable";
import VueMeta from "vue-meta";

Vue.component('FormBuilder', FormBuilder)
Vue.component('ITable', ITable)
Vue.use(VueMeta)
